import { useMemo } from "react";
import { HEADS_UP_UNLOCK_NOTE_COUNT_THRESHOLD } from "@/components/heads-up/constants";

export interface HeadsUpUnlockThresholdResult {
  threshold: number;
  notesRemaining: number;
  isLocked: boolean;
}

export function useHeadsUpUnlockThreshold({
  nullableUntrashedNoteCount,
}: {
  nullableUntrashedNoteCount: number | null;
}): HeadsUpUnlockThresholdResult {
  return useMemo(() => {
    const threshold = HEADS_UP_UNLOCK_NOTE_COUNT_THRESHOLD;

    // Only calculate lock status if we have real data
    // Optimistically assume unlocked until we have actual data to prevent flash
    const hasData = typeof nullableUntrashedNoteCount === "number";
    const safeCount = nullableUntrashedNoteCount ?? 0;
    const notesRemaining = threshold - safeCount;
    const isLocked = hasData ? notesRemaining > 0 : false;

    return {
      threshold,
      notesRemaining,
      isLocked,
    };
  }, [nullableUntrashedNoteCount]);
}
